export default {

    getFleetOperationStatus: {
        method: 'get',
        url: '/dashboard/fleet-operation/fleet-operation-status'
    },
    getDataFleetOperationStatus: {
        method: 'get',
        url: '/dashboard/fleet-operation/data-fleet-operation-status?type=TYPE'
    },

    getVehicleShipingStatus: {
        method: 'get',
        url: '/dashboard/fleet-operation/vehicle-shiping-status'
    },
    getDataVehicleShipingStatus: {
        method: 'get',
        url: '/dashboard/fleet-operation/data-vehicle-shiping-status?type=TYPE'
    }
}
